"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRadioGroupPropertySelector = createRadioGroupPropertySelector;
const react_1 = __importDefault(require("react"));
const property_1 = require("@promaster-sdk/property");
const radio_group_1 = require("./radio-group");
const radio_group_item_1 = require("./radio-group-item");
const defaultRadioGroupItem = (props) => (react_1.default.createElement(radio_group_item_1.RadioGroupItem, Object.assign({}, props, { style: {
        cursor: props.isItemValid ? "pointer" : "not-allowed",
        display: "inline-block",
        marginRight: "10px",
        padding: "10px",
        border: props.selected
            ? "2px solid " + (props.isItemValid ? "#39f" : "red")
            : "2px solid transparent",
        color: props.isItemValid ? "black" : "grey"
        // ${(p: RadioGroupItemProps) =>
        //   p.isItemValid ? "&:hover { background: #39f; color: white;" : ""}
    } })));
const defaultRadioGroup = (props) => (react_1.default.createElement(radio_group_1.RadioGroup, Object.assign({}, props)));
function createRadioGroupPropertySelector({ RadioGroupItem = defaultRadioGroupItem, RadioGroup = defaultRadioGroup }) {
    return function RadioGroupPropertySelector({ propertyName, propertyValueSet, valueItems, showCodes, onValueChange, filterPrettyPrint, readOnly, locked, comparer }) {
        const value = property_1.PropertyValueSet.getValue(propertyName, propertyValueSet);
        const safeComparer = comparer || property_1.PropertyValue.defaultComparer;
        if (!valueItems) {
            valueItems = [];
        }
        // Convert value items to options
        const items = valueItems
            .map(valueItem => {
            const isItemValid = _isValueItemValid(propertyName, propertyValueSet, valueItem, safeComparer);
            return {
                key: valueItem.sortNo.toString(),
                sortNo: valueItem.sortNo,
                selected: valueItem.value
                    ? property_1.PropertyValue.equals(value, valueItem.value, safeComparer)
                    : false,
                label: _getItemLabel(valueItem, showCodes),
                imageUrl: valueItem.image,
                toolTip: isItemValid
                    ? ""
                    : _getItemInvalidMessage(valueItem, filterPrettyPrint),
                onClick: () => !readOnly && valueItem.value && onValueChange(valueItem.value),
                isItemValid: isItemValid
            };
        })
            .sort((a, b) => a.sortNo - b.sortNo);
        return (react_1.default.createElement(RadioGroup, { locked: locked }, items.map(item => (react_1.default.createElement(RadioGroupItem, Object.assign({}, item))))));
    };
}
function _getItemLabel(valueItem, showCodes) {
    if (valueItem.value === undefined || valueItem.value === null) {
        return "";
    }
    return (valueItem.text +
        (showCodes ? ` (${property_1.PropertyValue.toString(valueItem.value)}) ` : ""));
}
function _getItemInvalidMessage(valueItem, filterPrettyPrint) {
    return filterPrettyPrint(valueItem.validationFilter);
}
function _isValueItemValid(propertyName, propertyValueSet, valueItem, comparer) {
    if (valueItem.value === undefined || valueItem.value === null) {
        return true;
    }
    const pvsToCheck = property_1.PropertyValueSet.set(propertyName, valueItem.value, propertyValueSet);
    if (!valueItem.validationFilter) {
        return true;
    }
    return property_1.PropertyFilter.isValid(pvsToCheck, valueItem.validationFilter, comparer);
}
//# sourceMappingURL=radio-group-property-selector.js.map